var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-composer" } }, [
    !_vm.selectedMailItem
      ? _c("div", { staticClass: "title-wrapper" }, [
          _c("div", { staticClass: "title" }, [_vm._v("Compose new email")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "close-button", on: { click: _vm.closeEditor } },
            [_c("span", { staticClass: "material-icons" }, [_vm._v(" close ")])]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "email-editor" }, [
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "email-editor" },
          [
            _c("MailAddressList", {
              attrs: {
                label: "from",
                defaultFromMember: _vm.defaultFromMember,
              },
              on: {
                selectedMembers: function (v) {
                  return (_vm.selectedFromMember = v)
                },
              },
            }),
            _vm._v(" "),
            _c("MailAddressList", {
              attrs: { label: "to", defaultToMember: _vm.defaultToMember },
              on: {
                selectedMembers: function (v) {
                  return (_vm.selectedToMembers = v)
                },
                selectedCcOrBcc: function (value) {
                  return _vm.changeSelectedCcOrBcc(value)
                },
              },
            }),
            _vm._v(" "),
            _vm.selectedCC
              ? _c("MailAddressList", {
                  attrs: { label: "cc" },
                  on: {
                    selectedMembers: function (v) {
                      return (_vm.selectedCCMembers = v)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedBCC
              ? _c("MailAddressList", {
                  attrs: { label: "bcc" },
                  on: {
                    selectedMembers: function (v) {
                      return (_vm.selectedBCCMembers = v)
                    },
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.selectedMailItem
              ? _c(
                  "div",
                  { staticClass: "subject-container" },
                  [
                    _c("div", { staticClass: "subject" }, [_vm._v("Subject:")]),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "subject-input",
                      model: {
                        value: _vm.subject,
                        callback: function ($$v) {
                          _vm.subject = $$v
                        },
                        expression: "subject",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { position: "relative" } },
          [
            _c("quill-editor", {
              ref: "myQuillEditor",
              staticStyle: { "max-height": "14%" },
              attrs: { id: "chat-editor", options: _vm.editorOption },
              on: {
                change: function ($event) {
                  return _vm.onEditorChange($event)
                },
              },
              model: {
                value: _vm.replyContentClone,
                callback: function ($$v) {
                  _vm.replyContentClone = $$v
                },
                expression: "replyContentClone",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "placeholder" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "variables" },
            [
              _c(
                "div",
                {
                  staticClass: "action-button",
                  on: {
                    click: function ($event) {
                      _vm.aiCopilot = { type: "fix-grammar" }
                    },
                  },
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("emoji_objects"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.aiCopilot
                ? _c("AICopilot", {
                    attrs: {
                      type: "mail",
                      mailText: _vm.replyContentClone,
                      mailDetails: _vm.firstMailBodyText,
                    },
                    on: {
                      close: function ($event) {
                        _vm.aiCopilot = null
                      },
                      change: function ($event) {
                        _vm.replyContentClone = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.attachments.length > 0
          ? _c(
              "div",
              { staticClass: "attachments" },
              _vm._l(_vm.attachments, function (attachment, index) {
                return _c("div", { staticClass: "attachment" }, [
                  _c("div", { staticClass: "left" }, [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons",
                        staticStyle: { "font-size": "16px" },
                      },
                      [_vm._v("attach_file")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "filename" }, [
                      _vm._v(_vm._s(attachment.file.name)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "size" }, [
                      _vm._v("(" + _vm._s(attachment.newSize) + " kB)"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.fileLoading === 100
                    ? _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: {
                            "font-size": "16px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteAttachment(index)
                            },
                          },
                        },
                        [_vm._v("delete")]
                      )
                    : _c("span", [_vm._v(_vm._s(_vm.fileLoading) + "%")]),
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "left" }, [
            _c(
              "button",
              {
                staticClass: "attache_file_btn",
                on: { click: _vm.selectFile },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "20px", color: "black" },
                  },
                  [_vm._v("attach_file")]
                ),
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("mail.attacheFiles")) +
                    "\n                    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c(
              "button",
              { staticClass: "cancel", on: { click: _vm.closeEditor } },
              [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "send",
                class: !_vm.sendButtonEnable ? "disable" : "",
                attrs: { disabled: !_vm.sendButtonEnable },
                on: { click: _vm.sendMail },
              },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("wp.send")) +
                    "\n                        "
                ),
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: {
                      "font-size": "20px",
                      "margin-left": "5px",
                      color: "white",
                    },
                  },
                  [
                    _vm._v(
                      "\n                            send\n                        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _vm._v("\n                    Placeholders\n                    "),
      _c(
        "span",
        { staticClass: "material-icons", staticStyle: { "font-size": "16px" } },
        [_vm._v("help")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }